module.exports = __webpack_public_path__ + "static/fonts/PingFang Medium.15974853.ttf";